import { Row, Col } from 'reactstrap';
import { MdPhonelinkRing } from 'react-icons/md';

const QuickService = () => {
    return (
        <Row className='my-3'>
            <Col className='d-flex align-items-center' xs='12' sm='12' md='6' lg='6'>
                <div>
                    <h2>Quick Service on Emergency Call - 24/7</h2>
                    <p>Our continuous pursuit of perfection has resulted in consistent growth each year. Our focus is to listen to our clients, understand their needs, and provide an exceptional level of residential and commercial cleaning services</p>
                    <h1><MdPhonelinkRing /> +971501790123</h1>
                </div>
            </Col>
            <Col xs='12' sm='12' md='6' lg='6'>
                <img src="/Assets/handyman.jpg" className='img-thumbnail img-fluid rounded' width='100%' height='100%' alt="" />
            </Col>
        </Row>
    );
};

export default QuickService;